/**
 * Benefits Slider - Expandable tall tile carousel
 * Handles expand/collapse of benefit cards with fixed height layout
 */
class BenefitsSlider extends HTMLElement {
    constructor() {
        super();
        this.cards = this.querySelectorAll('[data-benefits-card]');
        this.handleResize = this.#handleResize.bind(this);
        this.#init();
    }

    #init() {
        this.#setCardHeights();

        this.cards.forEach((card) => {
            const button = card.querySelector('[data-benefits-expand]');
            const content = card.querySelector('[data-benefits-content]');

            if (!button || !content) return;

            button.addEventListener('click', (event) => {
                event.preventDefault();
                this.#toggleCard(card, button, content);
            });
        });

        window.addEventListener('resize', this.handleResize);
    }

    disconnectedCallback() {
        window.removeEventListener('resize', this.handleResize);
    }

    #toggleCard(card, button, content) {
        const isExpanded = card.classList.contains('benefits-slider-card--expanded');

        if (isExpanded) {
            card.classList.remove('benefits-slider-card--expanded');
            button.setAttribute('aria-expanded', 'false');
            content.setAttribute('aria-hidden', 'true');
            content.setAttribute('inert', '');
        } else {
            card.classList.add('benefits-slider-card--expanded');
            button.setAttribute('aria-expanded', 'true');
            content.setAttribute('aria-hidden', 'false');
            content.removeAttribute('inert');
        }
    }

    #handleResize() {
        this.#setCardHeights();
    }

    #setCardHeights() {
        for (const card of this.cards) {
            card.style.removeProperty('--benefits-slider-card-height');
        }

        let maxHeight = 0;
        for (const card of this.cards) {
            const overlay = card.querySelector('.benefits-slider-card__overlay');
            const height = overlay?.scrollHeight ?? card.offsetHeight;
            maxHeight = Math.max(maxHeight, height);
        }

        for (const card of this.cards) {
            card.style.setProperty('--benefits-slider-card-height', `${maxHeight}px`);
        }
    }
}

customElements.define('benefits-slider', BenefitsSlider);
